import {
  findNode,
  getPluginType,
  ELEMENT_TR,
  ELEMENT_TD,
} from '@udecode/plate';

export const getCurrentCellData = (editor, selectedCells, at) => {
  const isSelectingMultipleCells = Array.isArray(selectedCells) ? selectedCells.length > 1 : false;
  const currentRow = findNode(editor, {
    match: { type: getPluginType(editor, ELEMENT_TR) },
    // Force current row to a different cell if path is provided
    ... at && { at },
  });
  const currentCell = findNode(editor, {
    match: { type: getPluginType(editor, ELEMENT_TD) },
    // Force current cell to a different cell if path is provided.
    ... at && { at },
  });
  const currentRowPath = currentRow?.length ? currentRow[1] : null;
  const currentColPath = currentCell?.length ? currentCell[1] : null;
    // We only want allow cell merging if selecting cells in the same row.
  // This will help reduce complexity until plate develops this feature.
  const currentRowChildren = (currentRow && currentRow.length && currentRow[0].children) ? currentRow[0].children : [];
  const currentRowChildrenIds = currentRowChildren ? currentRowChildren.map(cell => cell.id) : [];
  const isSelectingCellsInSameRow = isSelectingMultipleCells ?
    selectedCells.every(cell => currentRowChildrenIds.includes(cell.id)) :
    false;
  // It's possible this is true if multiple cells is selected and one of them has a colspan.
  const isInMergedCell = currentCell && !!currentCell[0]?.colSpan && !selectedCells;
  const colSpan = currentCell && currentCell[0].colSpan;

  return {
    currentRow,
    currentCell,
    currentRowPath,
    currentColPath,
    currentRowChildren,
    currentRowChildrenIds,
    isSelectingCellsInSameRow,
    isInMergedCell,
    colSpan,
  };
};
